import { render } from "./ClientAuthLayout.vue?vue&type=template&id=38e43a2f"
import script from "./ClientAuthLayout.vue?vue&type=script&lang=js"
export * from "./ClientAuthLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__